import { emptyContentActivityList, removeContentActivityFilter } from '../../../reducers/actions/customer.content.activity.actions';
var template = '<content-activity></content-activity>';
var params = {
  deviceName: null,
  previousRoute: null
};
export var DETAIL_STATE_OR_NAME = 'index.customercare.customer.contentActivity.product';
export var DEVICE_DETAIL_STATE_OR_NAME = 'index.customercare.customer.contentActivity.device';
export default (function ($stateProvider) {
  $stateProvider.state('index.customercare.customer.contentActivity', {
    template: template,
    url: '/contentActivity',
    params: params,
    onExit: function onExit($ngRedux) {
      $ngRedux.dispatch(removeContentActivityFilter());
      $ngRedux.dispatch(emptyContentActivityList());
    }
  }).state(DETAIL_STATE_OR_NAME, {
    template: template,
    url: '/product/:productId?{lockerItemId}',
    params: params
  }).state(DEVICE_DETAIL_STATE_OR_NAME, {
    template: template,
    url: '/device/:deviceId',
    params: params
  });
});